import angular from 'angular'
import './paginationFooter.scss'

// components
import paginationFooter from './component/paginationFooter.js'

export default angular
  .module('portalApp.paginationFooter', [])
  .component('paginationFooter', paginationFooter).name
